import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { MenuButton } from '@src/elements/button/button'
import Checkup, { CheckupState } from '@src/data/checkup'
import { API } from '@src/lib/api_path'
import ApiClient from '@src/lib/api_client'
import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { NotificationTypes } from '@src/util/constants'

@Component
export class CheckupOptionsCell extends ListCell {

  private checkup: Checkup
  private removeCallback: (checkupId: number) => void

  private apiClient: ApiClient

  private showConfirmPopup: boolean = false

  constructor () {
    super()

    this.apiClient = new ApiClient()
  }

  redirect (action: string) {
    this.$store.dispatch('setCheckup', this.checkup)
    this.$router.push({ path: `/trainers/checkup/${this.$route.params.id}/${this.checkup.id}`, query: { action: action } })
  }

  showRemoveConfirm () {
    this.showConfirmPopup = true
  }

  remove (confirm: boolean) {
    if (confirm === true) {
      this.apiClient.delete<any>(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${this.checkup.id}`)
        .then(() => {
          this.removeCallback(this.checkup.id)
          this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.CHECKUPS.DELETE_CHECKUP_SUCCESSFUL'), fadeOut: true })
        })
        .catch(error => console.error('failed to remove checkup', error))
    }
    this.showConfirmPopup = false
  }

  render (h: CreateElement) {
    return <div class='cell options-cell text-cell'>
      <MenuButton>
        <Popover>
          <OptionGroup>
            {this.checkup.state !== CheckupState.COMPLETED ?
              <div onClick={() => this.redirect('edit')} ref='editCheckup'><Subtitle1>{this.$t('PAGE.MEMBERS.CHECKUPS.EDIT_CHECKUP')}</Subtitle1></div> : null}
            {this.checkup.state === CheckupState.COMPLETED ?
              <div onClick={() => this.redirect('view')} ref='viewCheckup'><Subtitle1>{this.$t('PAGE.MEMBERS.CHECKUPS.VIEW_CHECKUP')}</Subtitle1></div> : null}
            <div onClick={this.showRemoveConfirm} ref='removeCheckup'><Subtitle1>{this.$t('PAGE.MEMBERS.CHECKUPS.DELETE_CHECKUP')}</Subtitle1></div>
          </OptionGroup>
        </Popover>
      </MenuButton>

      {this.showConfirmPopup ?
        <ConfirmModal show={this.showConfirmPopup}
                      closeCallback={this.remove}
                      message={this.$t('PAGE.MEMBERS.CHECKUPS.CONFIRM_REMOVE')}
                      type={NotificationTypes.CONFIRM} /> : null}
    </div>
  }

  created () {
    this.setCheckup()
    this.$watch('item', () => {
      this.setCheckup()
      this.$forceUpdate()
    })
  }

  setCheckup () {
    this.checkup = this.item[this.name].checkup
    this.removeCallback = this.item[this.name].removeCallback
  }
}
